import querystring from 'query-string';

export const queryParam = string => {
	return querystring.parse(string)
}